import "./instrument";

import { StrictMode } from "react";
import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("No #root element");

const handleUncaughtError = Sentry.reactErrorHandler();
const handleCaughtError = Sentry.reactErrorHandler();
const handleRecoverableError = Sentry.reactErrorHandler();

createRoot(root, {
  onUncaughtError: (error, errorInfo) => {
    handleUncaughtError(error, {
      componentStack: errorInfo.componentStack ?? null,
    });
  },
  onCaughtError: (error, errorInfo) => {
    handleCaughtError(error, {
      componentStack: errorInfo.componentStack ?? null,
    });
  },
  onRecoverableError: (error, errorInfo) => {
    handleRecoverableError(error, {
      componentStack: errorInfo.componentStack ?? null,
    });
  },
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
